import { useConfigContext } from "@/app";
import { Layout } from "@/components/Layout";
import { cn } from "@/libs";
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import styles from "./index.module.scss";
import {
  Header,
  HeaderActionCustomerService,
} from "@/components/Header";

export const LayoutAuth = () => {
  const {config} = useConfigContext();
  const versionText = React.useMemo(() => {
    return `版本号：V${config?.appVersion?.currentVersion}`
  }, [config?.appVersion])
  return (
    
      <div className={styles.layout}>
        <Layout
          header={
            <Header
              title=" "
              rightActions={<HeaderActionCustomerService />}
            />
          }
        >

        <div className={styles.logo}></div>
          <div className={styles.tabWrapper}>
            <NavLink
              className={({ isActive }) =>
                cn(styles.tabItem, { [styles.tabItemActive]: isActive })
              }
              to="/auth/login"
              replace
            >
              登录
            </NavLink>
            <NavLink
              className={({ isActive }) =>
                cn(styles.tabItem, { [styles.tabItemActive]: isActive })
              }
              to="/auth/register"
              replace
            >
              注册
            </NavLink>
          </div>
          <Outlet />

          {/* TODO: 版本号以编译时设置的为准 */}
        <div className={cn(styles.appVersion)}>{versionText}</div>
        </Layout>
        
      </div>
    
  );
};
